@use "../../sass/variables/colors" as colors;
@use "../../sass/mixins/font-family" as font-family;

/* stylelint-disable selector-max-id */

:host {
    --ux-popover-panel-border-width: 0;
    --ux-popover-panel-border-color: transparent;
    --ux-popover-panel-padding: 0;
}

:host * {
    box-sizing: inherit;
}

#panel {
    @include font-family.font(light);
    width: 268px;
}

#header {
    padding: 15px 20px 0;
    position: relative;
    color: #5a5a5a;

    span {
        display: block;
        margin-right: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        @include font-family.font(bold);
    }
}

#links {
    padding: 5px 20px 10px;

    a {
        @include font-family.font(light);
        font-size: 13px;
        text-transform: none;
        text-decoration: none;
        color: #5a5a5a;
        display: block;
        margin: 5px 0;

        &:hover {
            color: #000;
            text-decoration: underline;
        }
    }
}

#accounts {
    padding: 10px 20px;
    background-color: colors.$color-blue-6;
}

#footer {
    @include font-family.font(bold);
    appearance: none;
    background-color: colors.$color-blue-5;
    color: colors.$color-black-1;
    border: 0 none;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    width: 100%;
    text-transform: uppercase;
    cursor: pointer;
    transition:
        background-color 0.2s ease-in-out,
        color 0.2s ease-in-out;

    &:hover {
        background-color: colors.$color-blue-headline;
        color: #fff;
    }
}

#logout {
    appearance: none;
    background-color: transparent;
    border: 0 none;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    color: #747474;

    &:hover {
        color: #000;
    }
}

.title {
    @include font-family.font(bold);
    font-size: 13px;
    color: #5a5a5a;
    text-transform: uppercase;
}

.switch {
    appearance: none;
    border: 0 none;
    border-radius: 0;
    @include font-family.font(light);
    font-size: 14px;
    display: flex;
    height: 40px;
    padding: 10px;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    color: #5a5a5a;
    width: 100%;
    cursor: pointer;
    margin: 5px 0;
    transition:
        background-color 0.2s ease-in-out,
        color 0.2s ease-in-out;

    &:hover,
    &.active {
        background-color: colors.$color-blue-headline;
        color: #fff;
    }
}

.account-label {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.account-active {
    flex: 0 0 auto;
    text-transform: uppercase;
}
